import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { Reference, Attachment, GuidelineLinkDto, ResourceTag } from '@treetop/shared/model';

import { AnchorLinkComponent } from './anchor-link/anchor-link.component';
import { AttachmentsComponent } from './attachments/attachments.component';
import { SidebarReferencesComponent } from './sidebar-references/sidebar-references.component';
import { SidebarResourceTagsComponent } from '../sidebar-resource-tags/sidebar-resource-tags.component';

export type GuidelineSidebarBasics = {
  links: GuidelineLinkDto[];
  references: Reference[];
  attachments: Attachment[];
  resourceTags?: ResourceTag[];
};

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'tt-guideline-component-sidebar-basics',
  templateUrl: './guideline-sidebar-basics.component.html',
  styleUrls: ['./guideline-sidebar-basics.component.scss'],
  imports: [AnchorLinkComponent, AttachmentsComponent, SidebarReferencesComponent, SidebarResourceTagsComponent],
})
export class GuidelineSidebarBasicsComponent {
  public references = input<Reference[]>();
  public links = input<GuidelineLinkDto[]>();
  public attachments = input<Attachment[]>();
  public resourceTags = input<ResourceTag[]>();

  public basicsChanged = output<GuidelineSidebarBasics>();

  protected onAttachmentsChanged(attachments: Attachment[]) {
    this.basicsChanged.emit({
      references: this.references(),
      links: this.links(),
      attachments,
      resourceTags: this.resourceTags(),
    });
  }

  protected onLinksChanged(links: GuidelineLinkDto[]) {
    this.basicsChanged.emit({
      references: this.references(),
      attachments: this.attachments(),
      links,
      resourceTags: this.resourceTags(),
    });
  }

  protected onReferencesChanged(references: Reference[]) {
    this.basicsChanged.emit({
      attachments: this.attachments(),
      links: this.links(),
      references,
      resourceTags: this.resourceTags(),
    });
  }

  protected onTagsChanged(tags: ResourceTag[]) {
    this.basicsChanged.emit({
      attachments: this.attachments(),
      links: this.links(),
      references: this.references(),
      resourceTags: tags,
    });
  }
}
